import * as React from 'react';
import { Route, Switch, Redirect } from 'react-router';
import { EnableLxLoginEnum, LxConfig, ROUTES } from 'global/constants';
import { LoginView } from 'auth/components/LoginView';
import { LXLoginView } from 'auth/components/LxLoginView';
import { LXSignUpView } from 'auth/components/LxSignUpView';
import { BookPage } from 'books/components';
import { ClassroomPage } from 'classrooms/components';
import { ClustersPage } from 'clusters/components';
import { NotificationPage } from 'notifications/components';
import { CommunityPage, DashboardPage, OrganizationDashboardPage } from 'dashboard';
import { ExplorePage } from 'explore/components';
import { About, Faq, Home } from 'home/components';
import {
    CookiesPage,
    EuropeanPersonalDataPage,
    PrivacyPolicyPage,
    TermsOfServicePage
} from 'legal/components';
import {
    ItemEditOlxPageWrapper,
    ItemEditPage,
    ItemPage,
    LibraryPage,
    PathwayEditPage,
    PathwayItemPage,
    PathwayPage,
    PeoplePage,
    RedirectToPathwayItemPage,
    OrganizationSearchPage,
} from 'library/components';
import { CollaboratorsPage, OrgProfilePage } from 'org/components';
import { DevDemoPage } from 'ui/DevDemoPage';
import { UserProfilePage, UserProfileEditPage } from 'user/components/UserProfile';
import { UserProfileSettings } from 'user/components/UserProfileSettings';
import { OnboardingPage } from 'user/components/UserRegistration/OnboardingPage';
import { SignupDenied, SignupDeniedReason } from 'user/components/UserRegistration/SignupDenied';
import { SignupPage } from 'user/components/UserRegistration/SignupPage';
import { RedirectPage } from './RedirectPage';
import { DiscussionThread } from 'discussions/components/DiscussionThread';
import {
    DiscussionCategoryPage,
    DiscussionHome,
    DiscussionSubCategoryPage,
} from 'discussions/components';
import { MessagePage } from 'messages/components';

export const ContentRoutes = () => {
    const lxLoginView = LxConfig.EnableLxLogin === EnableLxLoginEnum.Production ? LXLoginView : LoginView;
    const lxSignUpView = LxConfig.EnableLxLogin === EnableLxLoginEnum.Production ? LXSignUpView : SignupPage;
    return (
        <Switch>
            <Route path={ROUTES.General.ABOUT} component={About} />
            <Route path={ROUTES.General.EU_PERSONAL_DATA} component={EuropeanPersonalDataPage} />
            <Route path={ROUTES.General.COOKIES} component={CookiesPage} />
            <Route path={ROUTES.General.FAQ} component={Faq} />
            <Route path={ROUTES.General.PRIVACY_POLICY} component={PrivacyPolicyPage} />
            <Route path={ROUTES.General.SIGN_IN} component={lxLoginView} />
            <Route path={ROUTES.General.SIGN_UP} component={lxSignUpView} />
            {LxConfig.EnableLxLogin === EnableLxLoginEnum.Debug ? <Route path={ROUTES.General.LX_SIGN_IN} component={LXLoginView} /> : null}
            {LxConfig.EnableLxLogin === EnableLxLoginEnum.Debug ? <Route path={ROUTES.General.LX_SIGN_UP} component={LXSignUpView} /> : null}
            <Route path={ROUTES.General.SIGNUP_DENIED_SDN}
                render={() => <SignupDenied reason={SignupDeniedReason.SDN} />} />
            <Route path={ROUTES.General.ONBOARDING} component={OnboardingPage} />
            <Route path={ROUTES.General.TOS} component={TermsOfServicePage} />
            <Route path={ROUTES.Explore.HOME} component={ExplorePage} />
            <Route path={ROUTES.Library.BOOK} component={BookPage} exact={true} />
            <Route path={ROUTES.Library.CLUSTER} component={ClustersPage} />
            <Route path={ROUTES.Library.PATHWAY_NEW} component={PathwayEditPage} />
            <Route path={ROUTES.Library.PATHWAY_EDIT} component={PathwayEditPage} />
            <Route path={ROUTES.Library.PATHWAY_ITEM} component={PathwayItemPage} />
            <Route path={ROUTES.Library.PATHWAY_ITEM_ALT} component={RedirectToPathwayItemPage} />
            <Route path={ROUTES.Library.PATHWAY} component={PathwayPage} />
            <Route path={ROUTES.Library.HOME} component={LibraryPage} exact={true} />
            <Route path={ROUTES.Library.ITEM_NEW} component={ItemEditPage} />
            <Route path={ROUTES.Library.ITEM_EDIT} component={ItemEditPage} exact={true} />
            <Route path={ROUTES.Library.ITEM_EDIT_OLX} component={ItemEditOlxPageWrapper} exact={true} />
            <Route path={ROUTES.Library.ITEM} component={ItemPage} />
            <Route path={ROUTES.Messages.MESSAGE_NEW} component={MessagePage} />
            <Route path={ROUTES.Messages.MESSAGE} component={MessagePage} />
            <Route path={ROUTES.Messages.HOME} component={MessagePage} />
            <Route path={ROUTES.Dashboard.ORGANIZATION_CONTENT} component={OrganizationDashboardPage} />
            <Route path={ROUTES.Dashboard.LEARNER_CLASSROOMS} component={DashboardPage} />
            <Route path={ROUTES.Dashboard.EDUCATOR_CLASSROOMS} component={DashboardPage} />
            <Route path={ROUTES.Dashboard.FAVORITES} component={DashboardPage} />
            <Route path={ROUTES.Dashboard.HOME} component={DashboardPage} />
            <Route path={ROUTES.Community.MENTEES} component={CommunityPage} />
            <Route path={ROUTES.Community.MENTORS} component={CommunityPage} />
            <Route path={ROUTES.Community.SUBCATEGORY_THREAD_ROUTE} component={DiscussionThread} />
            <Route path={ROUTES.Community.SUBCATEGORY_ROUTE} component={DiscussionSubCategoryPage} />
            <Route path={ROUTES.Community.CATEGORY_ROUTE} component={DiscussionCategoryPage} />
            <Route path={ROUTES.Community.DISCUSSIONS} component={DiscussionHome} />
            <Route path={ROUTES.Community.HOME} component={CommunityPage} />
            <Route path={ROUTES.Classrooms.CLASSROOM_DISCUSSION_THREAD_POST} component={ClassroomPage} />
            <Route path={ROUTES.Classrooms.CLASSROOM_DISCUSSION_THREAD} component={ClassroomPage} />
            <Route path={ROUTES.Classrooms.CLASSROOM_DISCUSSION} component={ClassroomPage} />
            <Route path={ROUTES.Classrooms.CLASSROOM_LEARNERS} component={ClassroomPage} />
            <Route path={ROUTES.Classrooms.CLASSROOM_PROGRESS} component={ClassroomPage} />
            <Route path={ROUTES.Classrooms.CLASSROOM} component={ClassroomPage} />
            <Route path={ROUTES.People.HOME} component={PeoplePage} />
            <Route path={ROUTES.Organizations.HOME} component={OrganizationSearchPage} />
            <Route path={ROUTES.Users.PROFILE} component={UserProfilePage} />
            <Route path={ROUTES.Users.PROFILE_EDIT} component={UserProfileEditPage} />
            <Route path={ROUTES.Organizations.PROFILE_FILTERED} component={OrgProfilePage} />
            <Route path={ROUTES.Organizations.PROFILE} component={OrgProfilePage} />
            <Route path={ROUTES.Organizations.COLLABORATORS} component={CollaboratorsPage} />
            <Route path={ROUTES.Personal.PROFILE_SETTINGS} component={UserProfileSettings} />
            <Route path={ROUTES.Personal.NOTIFICATIONS} component={NotificationPage} />
            <Route path={ROUTES.Redirects.REDIRECT} component={RedirectPage} />
            <Redirect exact strict from={ROUTES.Redirects.ABE_CLUSTER_CUSTOM}
                to={ROUTES.Library.CLUSTER_SLUG('lx-cluster\\:abe')}
            />
            <Route path={ROUTES.Test.UI_DEMOS} component={DevDemoPage} />
            <Route path={ROUTES.All.HOME} component={Home} />
        </Switch>
    );
};
